var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 149"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3670_5618",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 19C17.1046 19 18.0222 18.0938 17.7787 17.0164C17.4068 15.3705 16.5761 13.8482 15.364 12.636C13.6761 10.9482 11.3869 10 9 10C6.61305 10 4.32387 10.9482 2.63604 12.636C1.42391 13.8482 0.593236 15.3705 0.221289 17.0164C-0.0221858 18.0938 0.895431 19 2 19L9 19H16Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 19C17.1046 19 18.0222 18.0938 17.7787 17.0164C17.4068 15.3705 16.5761 13.8482 15.364 12.636C13.6761 10.9482 11.3869 10 9 10C6.61305 10 4.32387 10.9482 2.63604 12.636C1.42391 13.8482 0.593236 15.3705 0.221289 17.0164C-0.0221858 18.0938 0.895431 19 2 19L9 19H16Z",
    stroke: "#0D3F67",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_3670_5618)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 150",
    d: "M12.5 4.05C12.5 5.04708 12.0957 6.18071 11.4295 7.06234C10.7604 7.94782 9.8919 8.5 9 8.5C8.1081 8.5 7.23961 7.94782 6.57049 7.06234C5.90427 6.18071 5.5 5.04708 5.5 4.05C5.5 2.08351 7.07284 0.5 9 0.5C10.9272 0.5 12.5 2.08351 12.5 4.05Z",
    stroke: "#0D3F67"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon-person.578cfb65f5af1305cd162233da8a0a42.svg";
export { ForwardRef as ReactComponent };